import { TradingShell } from '@/components/trading/TradingShell';

/**
 * Paper-trading shell — now a thin wrapper over the shared {@link TradingShell}
 * (asset tabs Equity|Forex × view tabs Manual|Automated). Equity→Automated keeps
 * the full scanner-driven automation page; Equity→Manual is the new order ticket.
 */
export function PaperTradingShell() {
  return <TradingShell environment="paper" />;
}

export default PaperTradingShell;
